import React from 'react';
import PropTypes from 'prop-types';
import { add, format } from 'date-fns';

const ConfirmationDetails = ({ code }) => {
  const purchasePriceInDollars = code.purchase_price / 100;
  const bulkQuantity = code.bulk_quantity;
  // This date relies on the expiration date being set one year from today
  const expirationDateObject = add(new Date(), { years: 1 });
  const formattedDate = format(expirationDateObject, 'MMMM d, yyyy');

  return (
    <section className="details columns">
      <table className="details__table">
        <thead className="details__header">
          <tr>
            <th className="details__item-column">Item</th>
            <th className="details__paid-column">Paid</th>
            <th className="details__code-column">Your press release code</th>
          </tr>
        </thead>
        <tbody className="details__body">
          <tr>
            <td className="details__item-column" data-header="Item">
              {`Press release package (${bulkQuantity} credits)`}
              <div className="details__expiration-date">
                {`Valid through ${formattedDate}`}
              </div>
            </td>
            <td className="details__paid-column" data-header="Paid">
              {`$${purchasePriceInDollars}`}
            </td>
            <td className="details__code-column" data-header="Your press release code">
              <span className="details__code">
                {code.name}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

ConfirmationDetails.propTypes = {
  code: PropTypes.shape({
    pk: PropTypes.number.isRequired,
    bulk_quantity: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    purchase_price: PropTypes.number.isRequired,
    purchase_date: PropTypes.string.isRequired,
    purchaser_name: PropTypes.string.isRequired,
    purchaser_email: PropTypes.string.isRequired,
    purchaser_company: PropTypes.string.isRequired,
    purchaser_title: PropTypes.string.isRequired,
    payment_intent_id: PropTypes.string.isRequired,
  }).isRequired,
};

export default ConfirmationDetails;
